let membersLoginWidgets;

export const getMembersLoginWidgets = () => membersLoginWidgets || [];
export const setMembersLoginWidgets = (newMembersLoginWidgets) => {
    membersLoginWidgets = newMembersLoginWidgets;
};
